/**
* DevExpress Dashboard (_cssHelper.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export function createCssPropertyWrapper(propertyName, propertyValue) {
    return { propertyName, propertyValue };
}
export function getEmptyCssPropertyWrappersArray() {
    return [];
}
const dashboardStyleTagClass = 'dx-dashboard-styles';
const dashboardStyleTagSelector = '.' + dashboardStyleTagClass;
export function findStylesElement(relativeElement) {
    const style = relativeElement?.closest('.dx-dashboard-widget-container')?.parentElement?.querySelector(dashboardStyleTagSelector);
    return style || document.querySelector(dashboardStyleTagSelector);
}
export function createStylesElement(rootElement = document.head, nonce) {
    let style = rootElement.querySelector(dashboardStyleTagSelector);
    if (!style) {
        style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.classList.add(dashboardStyleTagClass);
        if (nonce) {
            style.setAttribute('nonce', nonce);
        }
        rootElement.prepend(style);
    }
}
export function removeStylesElement() {
    findStylesElement()?.remove();
}
export function addToStyles(styles, relativeElement) {
    var style = findStylesElement(relativeElement);
    style.textContent += styles;
    return () => {
        style.textContent = style.textContent.replace(styles, '');
    };
}
export function createCssClass(cssSelector, cssProperties, relativeElement) {
    return addToStyles(cssSelector + ' {' + convertCssPropertyWrappersToString(cssProperties) + '}', relativeElement);
}
export function convertCssPropertyWrappersToString(properties) {
    return properties
        .filter(x => x && x.propertyValue)
        .map(value => value.propertyName + ': ' + value.propertyValue + ';')
        .join(' ');
}
export function convertCssPropertyWrappersToObject(properties) {
    return properties
        .filter(x => x && x.propertyValue)
        .reduce((result, current) => {
        result[current.propertyName] = current.propertyValue;
        return result;
    }, {});
}
